import React from "react";

import RadioCard from "../../formElement/RadioCard";
import {
  isRequiredQuestion,
  isValidValue,
  replacePlaceholdersWithComponents
} from "../../../../../utils";
import { FIELD_REQUIRED_MSG } from "../../../../../constants";

function isRadioQuestionValid(question, step, afterChange, service) {
  let isValid = true;
  if (isRequiredQuestion(question)) {
    isValid = isValidValue(question.answer);
    question.error = isValid ? null : FIELD_REQUIRED_MSG;
  }
  if (!question.error && question.answer && question.config && question.config.choices && !question.config.choices.find(o => o.uid == question.answer)){
    question.error = FIELD_REQUIRED_MSG;
    isValid = false;
  }
  return isValid;
}

export const RadioQuestionMethods = {
  required: isRequiredQuestion,
  valid: isRadioQuestionValid
}

const RadioQuestion = props => {
  const {
    question,
    onAnswerChange,
    replaceComponents,
    useCards,
  } = props;

  const label = question.question_text;
  const required = RadioQuestionMethods.required(question) || question.required_check;
  const options = (question.config.choices || []).map(item => ({
    id: item.id,
    value: item.uid,
    info_text: item.info_text,
    infoIconColor: item.infoIconColor,
    label: replaceComponents ? replacePlaceholdersWithComponents(item.text, replaceComponents) : item.text,
    disabled: item.disabled,
    disabledReason: item.disabledReason
  }));

  const handleChange = (value) => {
    question.error = null;  // clean error
    onAnswerChange(question.uid, value);
  };

  return (
    <RadioCard
      label={label}
      value={question.answer || ''}
      required={required}
      disabled={question.disabled}
      options={options}
      onChange={handleChange}
      custom_classes={question.custom_classes || {}}
      error={question.error}
      row={question.row}
      newDesign={useCards}
    />
  );
};

export const RadioCardsQuestion = props => {
  return <RadioQuestion {...props} useCards />
};

export default RadioQuestion;